import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getNotifications } from "../../api/notification";
import { GetNotificationsResponse } from "../../types/requestsOutputs";
import { NotificationPanel } from "../../components/cards/Notification";

const ActiveNotifications: React.FC = () => {
    const { i18n } = useTranslation();

    const [notifications, setNotifications] = useState<GetNotificationsResponse>([]);

    const getNotificationsAPI = async () => {
        const token = localStorage.getItem("token");
        if (!token) {
            console.error("No token found");
            return;
        }
        const data = await getNotifications({ token });
        if (data) {
            console.log("Notifications fetched successfully", data);
            setNotifications(data);
            // Handle the notifications data as needed
        } else {
            console.error("Failed to fetch notifications");
        }
    };

    useEffect(() => {
        getNotificationsAPI();
    }, []);

    // Get user's current language code (e.g., "FR", "EN")
    const userLocale = i18n.language?.toUpperCase().split("-")[0] || "EN";

    return (
        <div>
            <NotificationPanel
                notifications={notifications}
                locale={userLocale}
                refetch={() => getNotificationsAPI()}
            />
        </div>
    );
};

export default ActiveNotifications;
